module.exports = __webpack_public_path__ + "img/sayings@2x.c332224.jpg";